import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import BlogCard from "../Components/BlogCard";
import blogBanner from "../Assets/ProductImages/Product Melee/1.jpg";
import { Link } from "react-router-dom";
import { get } from "../apiService";
import { Pagination, Spin } from "antd";
import BannerComp from "../Components/BannerComp";
import { Fade } from "react-awesome-reveal";
import { MetaTags } from "react-meta-tags";

const Blog = () => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    totalPage: 0,
  });
  const [loading, setLoading] = useState(false);
  const [allquote, setAllQuote] = useState([]);

  useEffect(() => {
    const dbounce = setTimeout(() => {
      fetchData(pagination.current, pagination.pageSize);
    }, 300);

    return () => clearTimeout(dbounce);
    // eslint-disable-next-line
  }, []);

  const fetchData = async (current, pageSize) => {
    setLoading(true);
    try {
      const action = "fetch";
      const response = await get(
        `/exibition.php?limit=${pageSize}&page=${current}&type=blog&action=${action}`
      );
      // console.log("response.list",response)
      setAllQuote(response.list);
      setPagination((prevPagination) => ({
        ...prevPagination,
        current,
        pageSize,
        total: response.total,
      }));
      setLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const handleTableChange = (newPagination) => {
    const { current, pageSize } = newPagination;
    setPagination({
      ...pagination,
      current,
      pageSize,
    });

    fetchData(current, pageSize);
  };
  return (

    <>
      <MetaTags>
        <title>Best Diamond Supplier | Sejal Exports</title>
        <meta title="Best Diamond Supplier | Sejal Exports" />
        <meta name="description" content="Looking for the Best Diamond Supplier? Explore our selection of top-quality diamonds for jewellers & businesses, offering reliable service & competitive prices." />
        <meta name="keywords" content="Melee Diamonds For Jewellery,Best Diamonds Collection ,Diamond Wholesaler ,Fancy Color Diamonds ,Melee Diamonds,Certified Melee Diamonds,Fancy Diamonds With Different Shape,Black Diamonds ,Certified Diamonds,Customized Diamonds,Certified Fancy diamond,Natural Diamonds ,Calibrated Diamonds ,Best Ntural Diamond Supplier ,Best Natural Diamond Exhibition ,Best Natural Diamond Dealer,Reasonable Diamond In USA,Fast Delivery Diamonds ,High Quality Diamond In USA,Best Diamond Company In USA,Diamond For Jewelry In USA,cheapest Rate Diamond In USA,Natural Melee Diamond In USA,Reasonable Diamond In UK,Fast Delivery ,High Quality Diamond In UK,Best Diamond Company In UK,Diamond For Jewellery In UK,cheapest Rate Diamond In UK,Melee Diamond In UK,Reasonable Diamond In Canada,Fast Delivery ,High Quality Diamond In Canada,Best Diamond Company In Canada,Diamond For Jewellery In Canada,cheapest Rate Diamond In Canada,Melee Diamond In Canada,Reasonable Diamond In Australia,Fast Delivery ,High Quality Diamond In Australia,Best Diamond Company In Australia,Diamond For Jewellery In Australia,cheapest Rate Diamond In Australia,Melee Diamond In Australia,Reasonable Diamante In Mexico,Fast Delivery ,High Quality Diamante In Mexico,Best Diamante Company In Mexico,Diamante For joyas In Mexico,cheapest Rate Diamante In Mexico,Melee Diamante In Mexico,Reasonable Diamante In Columbia,Fast Delivery ,High Quality Diamante In Columbia,Best Diamante Company In Columbia,Diamante For joyas In Columbia,cheapest Rate Diamante In Columbia,Melee Diamante In Columbia,Reasonable Diamante In Italy,Fast Delivery ,High Quality Diamante In Italy,Best Diamante Company In Italy,Diamante For gioielli In Italy,cheapest Rate Diamante In Italy,Melee Diamante In Italy,Reasonable Diamant In France,Fast Delivery ,High Quality Diamant In France,Best Diamant Company In France,Diamant For bijoux In France,cheapest Rate Diamant In France,Melee Diamant In France,Reasonable Diamant In Germany,Fast Delivery ,High Quality Diamant In Germany,Best Diamant Company In Germany,Diamant For Schmuck In Germany,cheapest Rate Diamant In Germany,Melee Diamant In Germany,Reasonable diamant In Denmark,Fast Delivery ,High Quality diamant In Denmark,Best diamant Company In Denmark,diamant For Schmuck In Denmark,cheapest Rate diamant In Denmark,Melee diamant In Denmark,Reasonable diamant In Sweden,Fast Delivery ,High Quality diamant In Sweden,Best diamant Company In Sweden,diamant For smycke In Sweden,cheapest Rate diamant In Sweden,Melee diamant In Sweden,Reasonable Diamond In South Africa,Fast Delivery ,High Quality Diamond In South Africa,Best Diamond Company In South Africa,Diamond For Jewellery In South Africa,cheapest Rate Diamond In South Africa,Melee Diamond In South Africa,Reasonable Diamond In Hong Kong,Fast Delivery ,High Quality Diamond In Hong Kong,Best Diamond Company In Hong Kong,Diamond For Jewellery In Hong Kong,cheapest Rate Diamond In Hong Kong,Melee Diamond In Hong Kong,Reasonable Diamond In Dubai,Fast Delivery ,High Quality Diamond In Dubai,Best Diamond Company In Dubai,Diamond For Jewellery In Dubai,cheapest Rate Diamond In Dubai,Melee Diamond In Dubai,Reasonable Diamond In Malaysia,Fast Delivery ,High Quality Diamond In Malaysia,Best Diamond Company In Malaysia,Diamond For Jewellery In Malaysia,cheapest Rate Diamond In Malaysia,Melee Diamond In Malaysia,Reasonable Diamond In Singapore,Fast Delivery ,High Quality Diamond In Singapore,Best Diamond Company In Singapore,Diamond For Jewellery In Singapore,cheapest Rate Diamond In Singapore,Melee Diamond In Singapore,Reasonable Diamond In Thailand,Fast Delivery ,High Quality Diamond In Thailand,Best Diamond Company In Thailand,Diamond For Jewellery In Thailand,cheapest Rate Diamond In Thailand,Melee Diamond In Thailand,Certified diamonds In India,Luxury diamonds In Dubai,Best Diamonds In Singapore ,Best Natural Diamond Dealer in Hong Kong,Diamond Dealer in Malaysia,Best Diamond Dealer in Thailand,Best Diamond Dealer in America,Best Diamond Dealer in United Kingdom,Best Diamond Dealer in Europe,Best Diamond Dealer in United State,Best Diamond Dealer in Australia,Certified diamonds In India,Luxury diamonds In Dubai,Best Diamonds In Singapore ,Best Natural Diamond Dealer in Hong Kong,Diamond Dealer in Malaysia,Best Diamond Dealer in Thailand,Best Diamond Dealer in America,Best Diamond Dealer in United Kingdom,Best Diamond Dealer in Europe,Best Diamond Dealer in United State,Best Diamond Dealer in Australia" />
        <link rel="canonical" href="https://sejalexports.in/best-diamond-supplier" />
        <meta http-equiv="cache-control" content="no-cache" />
        <meta http-equiv="expires" content="0" />
        <meta http-equiv="pragma" content="no-cache" />
        <meta property="og:title" content="Best Diamond Supplier | Sejal Exports" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sejalexports.in/" />
        <meta property="og:description" content="Looking for the Best Diamond Supplier? Explore our selection of top-quality diamonds for jewellers & businesses, offering reliable service & competitive prices." />
        <meta property="og:image" content="https://sejalexports.in/static/media/logo.3d243a21eddc9f360630.png" />
      </MetaTags>
      <Spin spinning={loading}>
        <Header />

        <BannerComp
          title="Blog"
          breadcrumb={[
            {
              title: "Home",
              href: "/",
            },
            {
              title: "Blog",
            },
          ]}
          image={blogBanner}
        />

        <section className="education-all-para mb-5 pb-5">
          <div className="container">
            <div className="row">
              {allquote?.map((v, i) => (
                <div className="col-lg-4 col-md-6 my-4">
                  <Fade triggerOnce direction="up">
                    <Link to={`/view/${v.slug}`}>
                      <BlogCard
                        value={v}
                      />
                    </Link>
                  </Fade>
                </div>
              ))}
            </div>
            <Pagination
              current={pagination.current}
              pageSize={pagination.pageSize}
              total={pagination.total}
              onChange={(page, pageSize) =>
                handleTableChange({ current: page, pageSize })
              }
              className="user-list-pagination"
            />
          </div>
        </section>

        <Footer />
      </Spin>
    </>
  );
};

export default Blog;
